"use client";

import { useInfront } from "@/context/infront-context";
import { DEFAULT_CONTENT } from "@/services/infront/utils";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

type FinancialCalendarProps = {
  instrument?: { feed: number; ticker: string };
  countryCode?: string;
  showTicker?: boolean;
};

const ID = "financial-calendar";

const FinancialCalendar = (props: FinancialCalendarProps) => {
  const { isReady, load } = useInfront();

  const [hasContent, setHasContent] = useState(false);
  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.FinancialCalendarWidgetOptions();

      widgetOptions.hasContentCallback = (_hasContent: boolean) =>
        setHasContent(_hasContent);

      widgetOptions.showTicker = props.showTicker;
      widgetOptions.widgetTitle = "Företagskalender";
      widgetOptions.defaultContent = DEFAULT_CONTENT;
      widgetOptions.showCategory = true;
      widgetOptions.layout = window.Infront.FinancialCalendarLayout.EXPANDED;
      widgetOptions.pageItems = 50;

      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + 3);
      widgetOptions.endDate = endDate;

      if (props.countryCode) {
        widgetOptions.countryCodes = [props.countryCode];
      }

      if (props.instrument) {
        widgetOptions.instrument = props.instrument;
      }

      widgetRef.current = window.infront.financialCalendarWidget(
        `#${ID}`,
        widgetOptions
      );
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, props.countryCode, props.instrument, props.showTicker]);

  return (
    <div
      className={classNames("card !overflow-x-auto", {
        hidden: !hasContent,
      })}
      id={ID}
    />
  );
};

export default FinancialCalendar;
